export const CONTENT = {
  channelUrl: 'https://www.youtube.com/@ActuallyIndian_AI/',
  channelHandle: '@ActuallyIndian_AI',
  description:
    'Breaking down machine learning, AI systems, and production engineering for developers who want to go beyond notebooks.',
  videos: [
    {
      title: 'ML in production',
      note: 'How I think about deploying models: monitoring, drift, and when classical ML beats LLMs.',
      href: 'https://www.youtube.com/@ActuallyIndian_AI/',
      duration: 'Series',
    },
    {
      title: 'Building with AI tools',
      note: 'Practical walkthroughs on speech-to-text, agents, and shipping side projects.',
      href: 'https://www.youtube.com/@ActuallyIndian_AI/',
      duration: 'Tutorials',
    },
    {
      title: 'Career in ML engineering',
      note: 'Breaking into applied AI from India to Ireland: portfolios, interviews, and what hiring managers look for.',
      href: 'https://www.youtube.com/@ActuallyIndian_AI/',
      duration: 'Advice',
    },
  ],
};
